






















import Vue from "vue"
import { Locale } from "vue-i18n"

export default Vue.extend({
  props: {
    title: {
      required: true
    }
  },
  methods: {
    changeLocale(locale: Locale) {
      if (locale !== this.$root.$i18n.locale) {
        this.$root.$i18n.locale = locale
      }
    }
  }
})
